import { LogsService } from '@gtpl/shared-services/user-logs';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { HlPercentageAdapter } from './dto/hl-percentage.adapter';
import { HlPercentage } from './hl-percentage.entity';
import {  HlPercentagesController } from './hl-percentages.controller';
import { HlPercentagesService } from './hl-percentages.service';

@Module({
  imports: [
    
    TypeOrmModule.forFeature([HlPercentage]),
    // forwardRef(() => ClusterModule),
  ],
  controllers: [HlPercentagesController],
  providers: [HlPercentagesService,HlPercentagesController,ApplicationExceptionHandler, HlPercentageAdapter,LogsService],
  exports: [HlPercentagesService],
})
export class HlPercentagesModule {}
